import script from "./TheToast.vue?vue&type=script&setup=true&lang=js"
export * from "./TheToast.vue?vue&type=script&setup=true&lang=js"

import "./TheToast.vue?vue&type=style&index=0&id=0b827dff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b827dff"]])

export default __exports__